import { Image } from "@mantine/core";
import smart from "../../assets/Copy.png";
interface Props {
  isSmall?: boolean;
  isLoginPage?: boolean;
  isCustom: boolean;
  customUrl: string;
}

/**
 * Renders the SmartChat logo component.
 *
 * @param {Props} isSmall - Indicates if the logo should be rendered as a small version.
 * @return {JSX.Element} The rendered SmartChat logo component.
 */
const CustomLogo = ({ isSmall, isLoginPage, isCustom, customUrl }: Props) => {
  const widthValue = isLoginPage ? "1.09753rem" : "14.375rem";

  return (
    <div className="logo">
      <Image
        className="logo-black"
        src={isCustom && customUrl !== null ? customUrl : smart}
        alt="logo"
        style={{
          width: isSmall ? "3.19506rem" : widthValue,
        }}
      />
    </div>
  );
};

export default CustomLogo;
